import { createContext, useContext, useState, ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { profileKeys } from '@/hooks/useProfileQueries';

interface ProfileModalContextType {
  isOpen: boolean;
  openProfileModal: () => void;
  closeProfileModal: () => void;
}

const ProfileModalContext = createContext<ProfileModalContextType | undefined>(undefined);

export function ProfileModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();

  const openProfileModal = () => {
    // Invalidate profile cache to ensure fresh data when modal opens
    queryClient.invalidateQueries({ queryKey: profileKeys.all });
    setIsOpen(true);
  };
  const closeProfileModal = () => setIsOpen(false);

  return (
    <ProfileModalContext.Provider value={{ isOpen, openProfileModal, closeProfileModal }}>
      {children}
    </ProfileModalContext.Provider>
  );
}

export function useProfileModal() {
  const context = useContext(ProfileModalContext);
  if (context === undefined) {
    throw new Error('useProfileModal must be used within a ProfileModalProvider');
  }
  return context;
}
